<template>
    <v-row>
        <v-col cols="12" md="5">
            <h3 class='mb-3'>{{ $t('week.title') }}</h3>
            <p>{{ $t('week.subtitle') }}</p>
            <apexchart type="bar" height="350" :options="optionsWnLByWeek" :series="seriesWnLByWeek"></apexchart>
        </v-col>
        <v-col cols="12" md="7">
            <h3 class='mb-3'>{{ $t('hour_TimeStats.title') }}</h3>
            <p>{{ $t('hour_TimeStats.subtitle') }}</p>
            <apexchart type="bar" height="350" :options="optionsWnLByHour" :series="seriesWnLByHour"></apexchart>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "TimeStats",
    data() {
        return {
            // Series
            seriesWnLByWeek: [{
                name: 'Winner Trades',
                data: [0, 0, 0, 0, 0, 0],
                count: []
            }, {
                name: 'Losers Trades',
                data: [0, 0, 0, 0, 0, 0],
                count: []
            },],

            seriesWnLByHour: [{
                name: 'Winner Trades',
                data: [0, 0, 0, 0, 0, 0],
                count: []
            }, {
                name: 'Losers Trades',
                data: [0, 0, 0, 0, 0, 0],
                count: []
            },],
            // Options
            optionsWnLByWeek: {
                theme: {
                    mode: this.$store.state.currentTheme == "dark" ? "dark" : "light"
                },
                noData: {
                    text: 'No data for the current filter',
                    align: 'center',
                    verticalAlign: 'middle',
                    style: {
                        color: '#111111',
                        fontSize: '21px',
                        fontFamily: 'Ubuntu, sans-serif',
                    }
                },
                colors: ['rgb(36,120,81)', '#FF4747'],
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: false,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    y: {
                        formatter: function (value, opts) {
                            // eslint-disable-next-line no-console
                            console.log(this.seriesWnLByWeek);
                            return `$${value.toFixed(1)}<br>Trades: ${opts.w.config.series[opts.seriesIndex].count[opts.dataPointIndex]}`
                        }
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (value) {
                            let numberValue = (Math.abs(value) >= 1000000) ? `${Math.abs(value / 1000000).toFixed(1)}M` :
                                (Math.abs(value) >= 1000) ? `${Math.abs(value / 1000).toFixed(1)}k` : Math.abs(value.toFixed(0));
                            return (value >= 0) ? `$${numberValue}` : `-$${numberValue}`;
                        },
                        style: {
                            color: '#6C7079',
                        },
                    },
                },
                xaxis: {
                    categories: [this.$t('week.days.sunday'), this.$t('week.days.monday'), this.$t('week.days.tuesday'),
                    this.$t('week.days.wednesday'), this.$t('week.days.thursday'), this.$t('week.days.friday'), this.$t('week.days.saturday')],
                    title: {
                        text: 'Weekdays'
                    },
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            },
            optionsWnLByHour: {
                theme: {
                    mode: this.$store.state.currentTheme == "dark" ? "dark" : "light"
                },
                noData: {
                    text: 'No data for the current filter',
                    align: 'center',
                    verticalAlign: 'middle',
                    style: {
                        color: '#111111',
                        fontSize: '21px',
                        fontFamily: 'Ubuntu, sans-serif',
                    }
                },
                colors: ['rgb(36,120,81)', '#FF4747'],
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: false,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    },
                    events: {
                        //beforeMount: this.setGraphs()
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    y: {
                        formatter: function (value, opts) {
                            return `$${value.toFixed(1)}<br>Trades: ${opts.w.config.series[opts.seriesIndex].count[opts.dataPointIndex]}`
                        }
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (value) {
                            let numberValue = (Math.abs(value) >= 1000000) ? `${Math.abs(value / 1000000).toFixed(1)}M` :
                                (Math.abs(value) >= 1000) ? `${Math.abs(value / 1000).toFixed(1)}k` : Math.abs(value.toFixed(0));
                            return (value >= 0) ? `$${numberValue}` : `-$${numberValue}`;
                        },
                        style: {
                            color: '#6C7079',
                        },
                    },
                },
                xaxis: {
                    categories: [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                    title: {
                        text: 'Hours of day (00:00 to 23:00)'
                    },
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            },
        };
    },
    beforeMount() {
        this.setGraphs();
    },
    watch: {
        '$store.state.book.trades': function () {
            this.setGraphs();
        }
    },
    methods: {
        setGraphs() {
            let positiveTradesCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let negativeTradesCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let positiveTradesMonetary = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let negativeTradesMonetary = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let positiveTradesWeekCount = [0, 0, 0, 0, 0, 0, 0];
            let negativeTradesWeekCount = [0, 0, 0, 0, 0, 0, 0];
            let positiveTradesWeekMonetary = [0, 0, 0, 0, 0, 0, 0];
            let negativeTradesWeekMonetary = [0, 0, 0, 0, 0, 0, 0];
            let copyOfTrades = this.$store.state.book.trades.slice();

            copyOfTrades.forEach((trade) => {
                if (trade.netProfit > 0) {
                    positiveTradesCount[trade.openTime.getHours() - 1] = positiveTradesCount[trade.openTime.getHours() - 1] + 1;
                    positiveTradesWeekCount[trade.openTime.getDay()] = positiveTradesWeekCount[trade.openTime.getDay()] + 1;
                    positiveTradesMonetary[trade.openTime.getHours() - 1] = positiveTradesMonetary[trade.openTime.getHours() - 1] + trade.netProfit;
                    positiveTradesWeekMonetary[trade.openTime.getDay()] = positiveTradesWeekMonetary[trade.openTime.getDay()] + trade.netProfit;

                } else {
                    negativeTradesCount[trade.openTime.getHours() - 1] = negativeTradesCount[trade.openTime.getHours() - 1] + 1;
                    negativeTradesWeekCount[trade.openTime.getDay()] = negativeTradesWeekCount[trade.openTime.getDay()] + 1;
                    negativeTradesMonetary[trade.openTime.getHours() - 1] = negativeTradesMonetary[trade.openTime.getHours() - 1] + trade.netProfit;
                    negativeTradesWeekMonetary[trade.openTime.getDay()] = negativeTradesWeekMonetary[trade.openTime.getDay()] + trade.netProfit;
                }
            });
            // eslint-disable-next-line no-console
            console.log("Negative trades count / week: ", negativeTradesWeekCount);
            // eslint-disable-next-line no-console
            console.log("Positive trades count / week: ", positiveTradesWeekCount);
            this.seriesWnLByWeek = [{
                name: 'Winner Trades',
                data: positiveTradesWeekMonetary,
                count: positiveTradesWeekCount
            }, {
                name: 'Losers Trades',
                data: negativeTradesWeekMonetary,
                count: negativeTradesWeekCount
            },];
            this.seriesWnLByHour = [{
                name: 'Winner Trades',
                data: positiveTradesMonetary,
                count: positiveTradesCount
            }, {
                name: 'Losers Trades',
                data: negativeTradesMonetary,
                count: negativeTradesCount
            },];

            this.optionsWnLByWeek = {
                theme: {
                    mode: this.$store.state.currentTheme == "dark" ? "dark" : "light"
                },
                noData: {
                    text: 'No data for the current filter',
                    align: 'center',
                    verticalAlign: 'middle',
                    style: {
                        color: '#111111',
                        fontSize: '21px',
                        fontFamily: 'Ubuntu, sans-serif',
                    }
                },
                colors: ['rgb(36,120,81)', '#FF4747'],
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: false,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    y: {
                        formatter: function (value, opts) {
                            // eslint-disable-next-line no-console
                            console.log(this.seriesWnLByWeek);
                            return `$${value.toFixed(1)}<br>Trades: ${opts.w.config.series[opts.seriesIndex].count[opts.dataPointIndex]}`
                        }
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (value) {
                            let numberValue = (Math.abs(value) >= 1000000) ? `${Math.abs(value / 1000000).toFixed(1)}M` :
                                (Math.abs(value) >= 1000) ? `${Math.abs(value / 1000).toFixed(1)}k` : Math.abs(value.toFixed(0));
                            return (value >= 0) ? `$${numberValue}` : `-$${numberValue}`;
                        },
                        style: {
                            color: '#6C7079',
                        },
                    },
                },
                xaxis: {
                    categories: [this.$t('week.days.sunday'), this.$t('week.days.monday'), this.$t('week.days.tuesday'),
                    this.$t('week.days.wednesday'), this.$t('week.days.thursday'), this.$t('week.days.friday'), this.$t('week.days.saturday')],
                    title: {
                        text: 'Weekdays'
                    },
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            };
        },
    }
}
</script>



<style scoped></style>
